import type {
	CustomItem,
	DropCarouselType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropCarousel = (
	item: Item | CustomItem
): item is DropCarouselType => {
	return !!(item && item.__typename === 'Drop_Carousel');
};
